import {Model} from 'backbone';
import {flow, property} from 'lodash';
export const getSiteUuid = flow(
    property('site'),
    property('uuid'),
);

/**
 * @typedef {Object} SyndicationTargetObject
 * @property {string} packageType
 * @property {string} status
 * @property {number} position
 * @property {Object} site
 * @property {Object} section
 * @property {boolean} [readonly]
 */

/**
 * @typedef {Model.prototype} SyndicationTargetModel
 */
export default Model.extend({
    // this model doesn't have a real
    urlRoot() {
        return `/api/rest/facade/${this.get('packageType').toLowerCase()}/syndicate`;
    },
    idAttribute: 'uuid',
    defaults: {
        packageType: 'STORY',
        status: 'staged',
        position: 1,
        site: null,
        section: null,
    },
    /**
     * Initialize function for the SyndicationTargetModel
     *
     * @param {SyndicationTargetObject} target
     * @returns {void}
     */
    initialize(target) {
        const isNotAlert = target.packageType !== 'ALERT';
        const isRoot = target.section.name === 'Root';
        const hasRootPath = target.section.navigationPath === '/';

        if (isNotAlert && isRoot && hasRootPath) {
            Object.assign(
                target.section,
                {
                    name: 'Lead Stories',
                    uuid: target.site.uuid,
                    targetable: true,
                }
            );
        }
    },
});
